<template>
  <div>
    <el-dialog :visible.sync="visible" custom-class="whaty-dialog-form" @close="handleCancel">
      <div slot="title" class="popup-head">
        <span class="popup-tit">更换皮肤</span>
      </div>
      <div v-loading="loading">
        <div class="popup-body">
          <div class="popup-content popup-content-complex" style="overflow-y:auto; overflow-x:auto;">
            <div class="clearfix popup-content-in">
              <div>
                <el-tabs v-model="activeName" tab-position="left" @tab-click="switchTheme">
                  <el-tab-pane v-for="(item) in themeList" :key="item.name" :label="item.path" :name="item.name">
                    <span slot="label">{{item.title}}</span>
                    <img :src="item.imagePath" alt="" style="height: 100%;width: 100%;"></img>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="popup-foot">
        <a href="javascript:" class="btn btn-solid" @click="setTheme">确定</a>
        <a href="javascript:" class="btn btn-hollow" @click="handleCancel">取消</a>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    name: 'theme-switch',
    data() {
      return {
        activeName: '',
        themePath: '',
        visible: false,
        loading: false,
        themeList: [
          {
            title: '深蓝',
            name: 'main-blue-dark',
            color: '#006de7',
            path: 'static/styles/css/main-blue-dark.css',
            imagePath: 'static/styles/images/main-blue-dark.png'
          },
          {
            title: '蓝绿',
            name: 'main-cyan',
            color: '#03a0a6',
            path: 'static/styles/css/main-cyan.css',
            imagePath: 'static/styles/images/main-cyan.png'
          },
          {
            title: '绿色',
            name: 'main-green',
            color: '#6bb141',
            path: 'static/styles/css/main-green.css',
            imagePath: 'static/styles/images/main-green.png'
          },
          {
            title: '深绿',
            name: 'main-green-dark',
            color: '#209758',
            path: 'static/styles/css/main-green-dark.css',
            imagePath: 'static/styles/images/main-green-dark.png'
          },
          {
            title: '橙色',
            name: 'main-orange',
            color: '#dd771c',
            path: 'static/styles/css/main-orange.css',
            imagePath: 'static/styles/images/main-orange.png'
          },
          {
            title: '紫色',
            name: 'main-purple',
            color: '#475ec2',
            path: 'static/styles/css/main-purple.css',
            imagePath: 'static/styles/images/main-purple.png'
          },
          {
            title: '红色',
            name: 'main-red',
            color: '#df3b3b',
            path: 'static/styles/css/main-red.css',
            imagePath: 'static/styles/images/main-red.png'
          },
          {
            title: '黄色',
            name: 'main-yellow',
            color: '#e5a618',
            path: 'static/styles/css/main-yellow.css',
            imagePath: 'static/styles/images/main-yellow.png'
          }
        ]
      }
    },
    created() {
      this.initUserTheme()
    },
    methods: {
      show () {
        this.visible = true
      },
      hide () {
        this.visible = false
      },
      switchTheme (targetName) {
        this.activeName = targetName.name
        this.themePath = targetName.label
      },
      setTheme () { // 提交设置皮肤
        localStorage.setItem('theme', this.activeName)
        // 设置项目主题
        document.querySelector('link[name="theme"]').setAttribute('href', this.themePath)
        // 设置element-ui主题
        if (this.activeName) {
          document.querySelector('link[name="el-theme"]').setAttribute('href', 'static/styles/el-theme/' + this.activeName + '.css')
        } else {
          document.querySelector('link[name="el-theme"]').setAttribute('href', 'static/styles/el-theme/main-blue-dark.css')
        }
        this.$emit('theme-change-success')
      },
      handleCancel () {
        this.hide()
      },
      initUserTheme () {
        let theme = localStorage.getItem('theme')
        if (theme) {
          // 设置项目主题
          document.querySelector('link[name="theme"]').setAttribute('href', 'static/styles/css/' + theme + '.css')
          // 设置element-ui主题
          if (theme) {
            document.querySelector('link[name="el-theme"]').setAttribute('href', 'static/styles/el-theme/' + theme + '.css')
          } else {
            document.querySelector('link[name="el-theme"]').setAttribute('href', 'static/styles/el-theme/main-blue-dark.css')
          }
          this.activeName = theme
        } else {
          this.activeName = 'main-purple'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/theme-switch/theme-switch.vue